// import ReactGA from 'react-ga';
import Nav from './components/nav/Nav';
import Header from './components/header/Header';
import About from './components/about/About';
import Portfolio from './components/portfolio/Portfolio';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

const App = () => (
  <>
    <Header />
    <Nav />
    <About />
    <Portfolio />
    <Contact />
    <Footer />
  </>
);

export default App;
